import React from 'react';
import { CheckboxList } from '../../../shared';
import { useTranslation } from 'react-i18next';
import { getCheckboxItems } from '../getCheckboxItems';
export var LocationFilter = function (_a) {
    var locationFilterState = _a.locationFilterState, locationFilterOptions = _a.locationFilterOptions, locationLabels = _a.locationLabels, onFilterStateChange = _a.onFilterStateChange;
    var t = useTranslation().t;
    var _b = React.useMemo(function () {
        var count = 0;
        var selectedCount = 0;
        for (var locationKey in locationFilterState) {
            count++;
            if (!!locationFilterState[locationKey]) {
                selectedCount++;
            }
        }
        return [count, selectedCount];
    }, [locationFilterState]), locationCount = _b[0], selectedLocationCount = _b[1];
    var title = React.useMemo(function () {
        return t('shift_management_views_filters_Location_title', {
            locationCount: selectedLocationCount
        });
    }, [selectedLocationCount]);
    var checkboxListItems = getCheckboxItems(locationFilterOptions, {
        labelTextMap: locationLabels,
        alphabetize: true
    });
    return (React.createElement(CheckboxList, { disabled: locationCount === 1, title: title, dataTestId: "location-filters", checkboxState: locationFilterState, checkboxListItems: checkboxListItems, onStateChange: onFilterStateChange }));
};
